/**
 * TimelineFilterSearch Component
 *
 * Search input field for filtering timeline items by text.
 */

import React from "react";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

interface TimelineFilterSearchProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const TimelineFilterSearchBase: React.FC<TimelineFilterSearchProps> = ({
  value,
  onChange,
}) => {
  return (
    <div className="relative flex-1 max-w-md">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        placeholder="Search timeline items..."
        value={value}
        onChange={onChange}
        className="pl-9 bg-card border-gray-200 focus:border-blue-300 focus:ring-blue-200"
      />
    </div>
  );
};

export const TimelineFilterSearch = React.memo(TimelineFilterSearchBase);
